export const environment = {
  production: true,
  publicConfigUrl: '/api/public/configuration',
  localDevSsoRedirect: false,
  ssoLoginRedirectIntervalInHours: 24,

  sentryDisabledOnUrls: new RegExp('^(?!.*(?:rpqa20-gi.rampitplatform.com|rpqa20-postman.rampitplatform.com|localhost)).*$'),
  // sentry config
  sentry: {
    DSN: 'https://8d65ce6a860ac9a3bddd5edc252f944f@o4504165036457984.ingest.us.sentry.io/4511460451418112',
    // environment setting needs to be updated as per the environment this is deployed to
    environment: 'qa',
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  },
  sentryIgnoredErrors: ['auth/wrong-password', 'auth/invalid-email', 'auth/user-not-found'],
};
